<div class="modal-body" style="max-width: 800px; margin: auto; padding: 20px">
  <div style="text-align: center">
    <i class="pi pi-times-circle" style="font-size: 5rem; color: red"></i>
  </div>
  <h4 class="text-center" style="font-size: 2rem; margin-top: 20px">
    {{ rejectedCode != -11 ? 'PAGO NO COMPLETADO' : data?.detalleMensaje }}
  </h4>

  @if(rejectedCode != -11) {
  <div class="row">
    @if(country=='cl'){
    <div class="col-12 py-0 text-center fw-bold" style="font-size: 25px">
      <!-- <p *ngIf="data?.detalleMensaje">
          {{ data?.detalleMensaje }}
        </p> -->
    </div>
    } @else{
    <div class="col-12 text-center fw-bold">
      @if (data?.pedido) {
      <p>
        {{ data?.pedido }}
      </p>
      } @if (data?.fecha) {
      <p>Fecha: {{ data?.fecha }}</p>
      } @if (data?.detalleMensaje) {
      <p>
        {{ data?.detalleMensaje }}
      </p>
      }
    </div>
    }
  </div>

  @if (data?.proceso != 'Anulado' && !data?.pagoValidado) {
  <div class="row mb-3">
    <div
      class="col-12 py-0 text-center"
      style="font-size: 20px; font-weight: 600; margin-top: 20px"
    >
      Se ha interrumpido el proceso de pago y se ha anulado su compra.
    </div>
  </div>
  } } @if (!data?.pagoValidado) {
  <div class="col-12 py-0" class="text-center">
    <p-button
      [style]="{
        'margin-top': '20px',
        'font-size': '20px',
        padding: '10px 20px'
      }"
      name="Volver"
      (click)="closeDialog($event)"
    >
      Volver a intentarlo
    </p-button>
  </div>
  }
</div>
